/**
 * 'Adopt A Red Nose' monthly donation journey steps; a tweaked version of Monthly:
 */
import { Navigate, Outlet } from 'react-router-dom';

import { getCurrencySymbol } from '@/locale';
import ClientContainer from '@/services/client/ClientContainer';
import JourneyContainer from '@/services/journeys/JourneyContainer';
import ProvidersLibsContainer from '@/services/providersLibs/ProvidersLibsContainer';

import UserDetails from '@/features/userDetails/UserDetails';
import ShippingDetails from '@/features/shippingDetails/ShippingDetails';
import GocardlessPayment from '@/providers/gocardless/GocardlessPayment';
import GocardlessConfirmation from '@/providers/gocardless/GocardlessConfirmation';
import PaymentSuccess from '@/features/paymentProcess/PaymentSuccess';
import PaymentSubmitted from '@/features/paymentProcess/PaymentSubmitted';
import PaymentFailure from '@/features/paymentProcess/PaymentFailure';
import PaymentError from '@/features/paymentProcess/PaymentError';

const currencySymbol = getCurrencySymbol();

// This represents the number of steps when the user has opted OUT for postal rewards -
// as we're not able to call the required hooks here (to do this dynamically),
// we'll need to tweak this value within the PageHeader component itself:
const adoptARedNoseRouteSteps = 5;

const adoptARedNoseRoutes = {
  path: '/adopt-a-red-nose',
  element: (
    <ClientContainer clientOverride="aarn">
      <ProvidersLibsContainer>
        <JourneyContainer journey="monthly">
          <Outlet />
        </JourneyContainer>
      </ProvidersLibsContainer>
    </ClientContainer>
  ),
  children: [
    // Redirect from "/adopt-a-red-nose" index to "./user-details"
    {
      path: '',
      element: <Navigate to="./user-details" replace />,
    },
    {
      path: 'user-details',
      element: <UserDetails
        providerGroup="monthly"
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'shipping-details',
      element: <ShippingDetails
        providerGroup="monthly"
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'bank-payment',
      element: <GocardlessPayment
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'bank-confirmation',
      element: <GocardlessConfirmation
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'success',
      element: <PaymentSuccess
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'submitted',
      element: <PaymentSubmitted
        totalSteps={adoptARedNoseRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'failure',
      element: <PaymentFailure />,
    },
    {
      path: 'error',
      element: <PaymentError />,
    },
  ],
};

export default adoptARedNoseRoutes;
